import dayjsTZ from "../../../../../utils/dayjs";
import { getTodayKey } from "../../../selectors/todayClockings";

export const processClockings = (clockings, employees, todaysClockings) => {
  let floorTime = dayjsTZ().set("hour", 13).set("minute", 31).set("second", 30);

  let res = [];
  if (!!clockings && Array.isArray(clockings) && !!employees) {
    const todayKey = getTodayKey();
    const source =
      Array.isArray(todaysClockings) && todaysClockings.length >= 0
        ? todaysClockings
        : clockings.filter(
            (item) =>
              dayjsTZ(item.clockInDate).format("DD/MM/YYYY") === todayKey
          );

    const employeeById = new Map(
      (employees || []).map((e) => [e.employeeId, e])
    );

    source.forEach((element) => {
      let employeeFirstName = "";
      let employeeLastName = "";
      const test = employeeById.get(element?.employeeId);
      if (!!test) {
        employeeLastName = test?.employeeLastName || "";
        employeeFirstName = test?.employeeFirstName || "";
      }
      if (!!element?.clockOutDate) {
        res.push({
          ...element,
          employeeInfo: {
            name: employeeFirstName,
            surname: employeeLastName,
          },
          lateInfo: "clockOut",
          color: getColor("clockOut"),
          inOrOut: "out",
          time: element.clockOutDate,
        });
      }
      let minutesDiff = dayjsTZ(element.clockInDate).diff(
        floorTime,
        "minutes",
        true
      );
      if (minutesDiff < 0) {
        res.push({
          ...element,
          employeeInfo: {
            name: employeeFirstName,
            surname: employeeLastName,
          },
          lateInfo: "clockIn",
          color: getColor("clockIn"),
          inOrOut: "in",
          time: element.clockInDate,
        });
      } else if (minutesDiff > 0 && minutesDiff <= 5) {
        res.push({
          ...element,
          employeeInfo: {
            name: employeeFirstName,
            surname: employeeLastName,
          },
          lateInfo: "lateClockIn",
          color: getColor("lateClockIn"),
          inOrOut: "in",
          time: element.clockInDate,
        });
      } else if (minutesDiff > 5) {
        res.push({
          ...element,
          employeeInfo: {
            name: employeeFirstName,
            surname: employeeLastName,
          },
          lateInfo: "lateClockIn",
          color: getColor("extraLateClockIn"),
          inOrOut: "in",
          time: element.clockInDate,
        });
      }
    });
    return res.sort((a, b) => b.time - a.time);
  }
  return res;
};

const getColor = (type) => {
  let colors = {
    clockIn: "#1da193",
    lateClockIn: "#FCC94A",
    extraLateClockIn: "#ea3943",
    clockOut: "#E8E8E8",
  };
  return colors[type];
};
